export default {
    queryMonthlyFileList: '/basic/monthly/queryMonthlyFileList',
    exportPdf: '/basic/monthly/exportPdf',
    downloadPdf: '/basic/monthly/downloadPdf',
    createMonthlyFile: '/basic/monthly/createMonthlyFile',
    createMonthlyFileAi: '/basic/monthly/inner/createData',
    exportText: '/basic/monthly/export/inner',
    pushPurchaser: '/basic/monthly/inner/pushPurchaser',
    createHistoryData: '/basic/monthly/inner/createHistoryData',
    pushHistoryData: '/basic/monthly/inner/pushHistoryData',
    createMonthlyDataByHand: '/basic/monthly/createMonthlyDataByHand',
};
